//@ts-check
import React from 'react';
import JourneyTouchpoint from './JourneyTouchpoint';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MissingValue from '../MissingValue';
import { isSpecified } from '../util';
import DataItem from '../../data/Item';
var styles = createStyles({
  base: {
    fontSize: 'inherit',
    position: 'relative',
    width: '1.5em',
    textAlign: 'left'
  },
  touchpointDescriptionContainer: {
    paddingBottom: 12,
    paddingLeft: 12,
    borderLeft: '2px solid transparent',
    marginLeft: '5px',
    minHeight: '10px'
  }
});
/**
 *
 * @param {import('data/types/engagement/types').JourneyMapDataModel} journeySpecs
 */

var getStoryTouchpoints = function getStoryTouchpoints(journeySpecs) {
  var touchpoints = [];
  var mainStory = 1;
  journeySpecs.stages.slice().sort(function (a, b) {
    return a.index > b.index ? 1 : -1;
  }).forEach(function (stage) {
    return stage.touchpoints.filter(function (a) {
      return a.story === mainStory;
    }) //only main story
    .sort(function (a, b) {
      return a.left - b.left;
    }) //order by position
    .forEach(function (touchpoint) {
      var id = touchpoint.id,
          name = touchpoint.name,
          description = touchpoint.description,
          type = touchpoint.type,
          color = touchpoint.color;
      touchpoints.push({
        id: id,
        name: name,
        description: description,
        type: type === 'regular' ? 'touchpoint' : type,
        color: color,
        stageColor: stage.color
      });
    });
  });
  touchpoints.forEach(function (tchp, idx, tchps) {
    var nextTchp = tchps[idx + 1];
    tchp.isConnectedToNext = nextTchp && journeySpecs.connectors.find(function (c) {
      return c.type === 'solid' && c.start === tchp.id && c.end === nextTchp.id;
    });
  });
  return touchpoints;
};
/**
 * @param {import('@material-ui/core').WithStyles<typeof styles> &
 *        { name: string, description?: string, type?: 'touchpoint' | 'milestone', color?: string, stageColor?: string, isConnectedToNext?: boolean } } props
 */


var TouchpointNarrative = function TouchpointNarrative(_ref) {
  var name = _ref.name,
      description = _ref.description,
      type = _ref.type,
      color = _ref.color,
      isConnectedToNext = _ref.isConnectedToNext,
      stageColor = _ref.stageColor,
      classes = _ref.classes;
  if (!type) type = 'touchpoint';
  return React.createElement(React.Fragment, null, React.createElement(JourneyTouchpoint, {
    value: name,
    type: type,
    color: color
  }), React.createElement("div", {
    style: {
      borderLeftColor: isConnectedToNext ? stageColor : 'transparent'
    },
    className: classes.touchpointDescriptionContainer
  }, React.createElement(Typography, {
    display: "inline"
  }, description)));
};

TouchpointNarrative.defaultProps = {
  isConnectedToNext: false,
  fallback: React.createElement(MissingValue, null)
};
var TouchpointNarrativeContainer = withStyles(styles, {
  name: 'ECTouchpointNarrative'
})(TouchpointNarrative);

var JourneyNarrativeView = function JourneyNarrativeView(_ref2) {
  var touchpoints = _ref2.touchpoints;
  return touchpoints.map(function (touchpoint) {
    return React.createElement(TouchpointNarrativeContainer, Object.assign({
      key: 'tchp_' + touchpoint.id
    }, touchpoint));
  });
};
/**
 * @param {import('../types').FormatterProps<number> } props
 */


var JourneyNarrative = function JourneyNarrative(_ref3) {
  var value = _ref3.value,
      fallback = _ref3.fallback;
  if (!isSpecified(value)) return fallback;
  return React.createElement(DataItem, {
    dataType: "journeyMap",
    id: value
  }, function (_ref4) {
    var journeySpecs = _ref4.value;
    return isSpecified(journeySpecs) ? React.createElement(JourneyNarrativeView, {
      touchpoints: getStoryTouchpoints(journeySpecs)
    }) : fallback;
  });
};

JourneyNarrative.defaultProps = {
  fallback: React.createElement(MissingValue, null)
};
export default JourneyNarrative;